import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';


@Component({
    selector: 'app-sms-dialog',
    templateUrl: './sms-dialog.component.html',
    styleUrls: ['./sms-dialog.component.scss'],
    standalone: false
})
export class SmsDialogComponent {

	message: string;
	timer: number = 30;

	constructor(
		public appService: AppService,
		public entityService: EntityService,
		public dialogRef: MatDialogRef<SmsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		let messageKey = this.data.isRetry ? 'MESSAGES.PAYMENT_CHALLENGE_RETRY' : 'MESSAGES.PAYMENT_CHALLENGE';
		this.message = this.appService.translate(messageKey, { phone: this.appService.formatPhoneNumber(this.data.phone) });
		setInterval(() => {
			if (this.timer == 0) {
				return;
			}
			--this.timer;
		}, 1000);
	}
	
	verificationCode: string;
	apply(form) {
		if (!form.valid) return;
		this.dialogRef.close(this.verificationCode);
	}

	resendPinCode() {
		this.dialogRef.close("resend");
	}


}
